import { render, staticRenderFns } from "./OrderDetails.vue?vue&type=template&id=044cd8e4"
import script from "./OrderDetails.vue?vue&type=script&lang=js"
export * from "./OrderDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('044cd8e4')) {
      api.createRecord('044cd8e4', component.options)
    } else {
      api.reload('044cd8e4', component.options)
    }
    module.hot.accept("./OrderDetails.vue?vue&type=template&id=044cd8e4", function () {
      api.rerender('044cd8e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/OrderDetails.vue"
export default component.exports